import { createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import Types from '../Actions/Types'

export const INITIAL_STATE = Immutable({
    totalStudent: 0,
    studentList: [],
    newstudent:{},
    vaccines:{},
    setNewEpID:{},
    medicaldata:{},
    assessmentStatus:[],
    studentHeader: {
        "inLimit": 100,
        "inOffset": 0,
        "sortField":"firstname",
        "sortBy":"asc",
        "inSearchString":"",
        "class": "",
        "section": "",
        "ailment": ""


    },

    loaded: false,
    isLoading: false,
    childList: [],

    vaccineList: {
        loaded: false,
        isLoading: false,
        data: []
    },

    episodeHeader: {
        "inLimit": 5,
        "inOffset": 0,
        "inSortField": 'modified_time',
        "inSortBy": 'desc',
        "inStudentId": null,
        "inOrganizationId": null,
        "inSearchString": '',
        "inCustomFilter": ''
    },
    episodeList: [],
    episodeTotal: 0,
    clinicStudentHeader: {
        "inLimit": 5,
        "inOffset": 0,
        "inSortField": 'name, class, section',
        "inSortBy": 'desc',
        "inStudentId": null,
        "inOrganizationId": null,
        "inSearchString": '',
        "inCustomFilter": ''
    },
    clinicStudentList: [],
    clinicStudentTotal: 0,
    episodeStats: [],
    pdfContent: {}
}) 

const loadStudentReport = (state, action) => {
    return state.merge({
        pdfContent: action.report    
    })
}

const storeStudentList = (state, action) => {
    return state.merge({
        studentList: action.payload.students,
        totalStudent: action.payload.total,
        studentHeader: action.payload.studentHeader
    })
}

const storeStudentAssessmentStatus = (state, action) => {
    return state.merge({
        assessmentStatus: action.payload.studentAssessmentStatus,
    })
}
const storeStudentProfileSearch = (state, action) => {
    return state.merge({
        studentList: action.payload.students,
    })
}
const storenewstudent=(state, action)=>{

    return state.merge({

        newstudent: action.payload
     
    })
}

const fetchvaccinesdata=(state,action)=>{
    return state.merge({
        vaccineList: action.data
    })
};

const storeMedicalData=(state, action)=>{

    return state.merge({

        medicaldata: action.payload.students
     
    })
}



const storeClinicStudentSearch = (state, action) => {
    return state.merge({
        clinicStudentList: action.payload.students,
        clinicStudentTotal: action.payload.total,
        clinicStudentHeader: action.payload.header
    })
}


const setEpisodeSelectedStudentId= (state, action) => {
    return state.merge({
        clinicStudentList: action.payload.students,
        clinicStudentTotal: action.payload.total,
        clinicStudentHeader: action.payload.header
    })
}



const storeStudentEpisodeSearch = (state, action) => {
    return state.merge({
        episodeList: action.payload.episodes,
        episodeTotal: action.payload.total,
        episodeHeader: action.payload.header
    })
}

const storeStudentEpisodeSearchnew = (state, action) => {
    return state.merge({
        episodeList: action.payload.episodes,
        episodeTotal: action.payload.total,
        episodeHeader: action.payload.header
    })
}

const storeClinicEpisodeStats = (state, action) => {
    return state.merge({
        episodeStats: action.payload.stats,
    })
}


// for fetching the vaccinatin list //



const fetchingVaccination = (state, action) => {
    return state.merge({
        vaccineList: action.data.reults
          
    })
};

const responseVaccineList = (state, action) => {
    if(Boolean(action.response.ok)) {
        return state.merge({
            vaccineList: {
                loaded: true,
                isLoading: false,
                data: action.response.data
            }
        })
    }

    else {
        return state.merge({
            vaccineList: {
                isLoading: false,
                
            }
        })
    }
};


const fetchingChildList = (state, action) => {
    return state.merge({
        isLoading: true
        
    })
}


const responseChildList = (state, action) => {
    if(!action.response.ok) {
        return state.merge({
            isLoading: false,
            loaded: false,
            childList: [],
            selectedChild: 0
        })
    }

    else {
        return state.merge({
            isLoading: false,
            loaded: true,
            childList: action.response.childList,
            selectedChild: action.response.selectedChild
        })
    }
};

const updateChildSelection = (state, action) => {
    if(action.index >= 0 && action.index < state.childList.length) {
        return state.merge({
            selectedChild: action.index
        })
    }
    else {
        return state;
    }
};



const updateSelectedChildOnUpdate = (state, action) => {

    if (action.obj.newCustom) {
        let child  = state.childList[state.selectedChild].asMutable()
        let obj = {}
        
        obj = JSON.parse(action.obj.newCustom)
        child = Object.assign({}, child, obj)

        let updated = state.childList.asMutable()
        updated[state.selectedChild] = child

        return state.merge({
        childList : updated,
        updateChild: {
                isUpdating: false,
                status: false,
                error: ''
            }
        })
    }

}

const resetStudent = (state, action) => INITIAL_STATE

const ACTION_HANDLERS = {
    [Types.LOAD_STUDENT_REPORT]: loadStudentReport,
    [Types.STORE_STUDENT_LIST]: storeStudentList,
    [Types.STORE_STUDENT_PROFILE_SEARCH]:storeStudentProfileSearch,
    [Types.STORE_STUDENT_ASSESSMENT_STATUS]:storeStudentAssessmentStatus,
    [Types.RESET_STUDENT]: resetStudent,
    [Types.STORE_STUDENT_EPISODE_SEARCH]: storeStudentEpisodeSearch,
    [Types.STORE]: storeStudentEpisodeSearchnew,
    [Types.STORE_CLINIC_STUDENT_SEARCH]: storeClinicStudentSearch,
    [Types.STORE_NEW_STUDENT_ID]: setEpisodeSelectedStudentId,
    [Types.STORE_CLINIC_EPISODE_STATS]: storeClinicEpisodeStats,
    [Types.STORE_NEW_STUDENT]: storenewstudent,
    [Types.FETCH_CUSTOM_STUDENT_LIST]: storeMedicalData,

    // types for fetching the vaccination list //

    [Types.FETCH_VACCINATION]: fetchingVaccination,
    [Types.RESPONSE_VACCINATION]: responseVaccineList,

    [Types.FETCH_CHILD_LIST]: fetchingChildList,
    [Types.RESPONSE_CHILD_LIST]: responseChildList,
    [Types.UPDATE_SELECTED_CHILD_ON_UPDATE]: updateSelectedChildOnUpdate,
    [Types.SELECT_CHILD]: updateChildSelection,
    [Types.FETCH_VACCINATION]: fetchvaccinesdata,
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
